import { AttachmentUploadFn } from './useFroalaAttachments'
import { ImageUploadFn } from './useRichTextImageUpload'

const useEditorButtons = (
  isFullVersion: boolean = true,
  attachmentUploadFn?: AttachmentUploadFn,
  areGifsAvailable = false,
  hideButtons = false,
  imageUploadFn?: ImageUploadFn,
) => {
  if (hideButtons) {
    return {
      moreTextButtons: [],
      moreParagraphButtons: [],
      moreRichButtons: [],
      moreMiscButtons: [],
      pluginsEnabled: [],
      shortcutsEnabled: [],
    }
  }

  const moreTextButtonsFull = [
    'bold',
    'italic',
    'underline',
    'strikeThrough',
    'insertImage',
    ...(areGifsAvailable ? ['insertGif'] : []), // Custom GIF button
    'emoticons',
    ...(attachmentUploadFn ? ['insertAttachment'] : []), // Custom attachment button
    'subscript',
    'superscript',
    'fontFamily',
    'fontSize',
    'textColor',
    'backgroundColor',
    'inlineClass',
    'clearFormatting',
  ]

  const moreParagraphButtonsFull = [
    'alignLeft',
    'alignCenter',
    'formatOLSimple',
    'alignRight',
    'alignJustify',
    'formatOL',
    'formatUL',
    'paragraphFormat',
    'paragraphStyle',
    'lineHeight',
    'outdent',
    'indent',
    'quote',
  ]

  const moreRichButtonsFull = [
    'insertLink',
    // 'insertVideo',
    'insertTable',
    'fontAwesome',
    'specialCharacters',
    // 'embedly',
    // 'insertFile',
    // 'insertHR',
  ]

  const moreMiscButtonsFull = [
    'undo',
    'redo',
    // 'fullscreen',
    // 'print',
    // 'getPDF',
    // 'spellChecker',
    // 'selectAll',
    // 'html',
    // 'help',
  ]

  const pluginsEnabledFull = [
    'charCounter',
    'table',
    'spell',
    'quote',
    'save',
    'paragraphFormat',
    'paragraphStyle',
    // 'help', // See moreMiscButtonsFull above
    'draggable',
    'align',
    'link',
    'lists',
    'file',
    'image',
    'emoticons',
    'url',
    'video',
    'embedly',
    'colors',
    'entities',
    'inlineClass',
    'inlineStyle',
    'imageTUI',
  ]

  // See moreTextButtons for compact toolbar buttons
  const pluginsEnabledCompact = ['charCounter', 'lists', 'image', 'emoticons', 'file', 'entities']

  const moreTextButtons = [
    'bold',
    'italic',
    'underline',
    ...(imageUploadFn ? ['insertImage'] : []),
    ...(areGifsAvailable ? ['insertGif'] : []), // Custom GIF button
    'emoticons',
    ...(attachmentUploadFn ? ['insertAttachment'] : []), // Custom attachment button
    'formatOLSimple',
    'formatUL',
  ]

  // Only enable shortcuts whose plugin is in pluginsEnabled and whose button is in the
  // toolbar: plugins.pkgd pushes every shortcut onto global DEFAULTS.shortcutsEnabled,
  // and each command callback assumes its plugin was instantiated (e.g. help -> this.help).
  const shortcutsEnabledFull = [
    'bold',
    'italic',
    'underline',
    'strikeThrough',
    'indent',
    'outdent',
    'undo',
    'redo',
    'insertImage',
    'insertLink',
    'quote',
  ]

  const shortcutsEnabledCompact = [
    'bold',
    'italic',
    'underline',
    'undo',
    'redo',
    ...(imageUploadFn ? ['insertImage'] : []),
  ]

  return {
    moreTextButtons: isFullVersion ? moreTextButtonsFull : moreTextButtons,
    moreParagraphButtons: isFullVersion ? moreParagraphButtonsFull : [],
    moreRichButtons: isFullVersion ? moreRichButtonsFull : [],
    moreMiscButtons: isFullVersion ? moreMiscButtonsFull : [],
    pluginsEnabled: isFullVersion ? pluginsEnabledFull : pluginsEnabledCompact,
    shortcutsEnabled: isFullVersion ? shortcutsEnabledFull : shortcutsEnabledCompact,
  }
}

export default useEditorButtons
